export class FavoriteUserError extends Error {}
